import { useState, useEffect } from "react";
import { signOut } from "firebase/auth";
import { auth, db, storage } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Header from "./header";
import EditModal from "./EditModal";
import "../dashboard.css";

export default function Dashboard({ onLogout }) {
  const [image, setImage] = useState(null);
  const [title, setTitle] = useState("");
  const [caption, setCaption] = useState("");
  const [title2, setAnotherTitle] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [buttonLink, setButtonLink] = useState("");
  const [order, setOrder] = useState("");
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");
  const [images, setImages] = useState([]);
  const [editingItem, setEditingItem] = useState(null);

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "homeBanner"));
      const imageList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setImages(imageList.sort((a, b) => a.order - b.order));
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    onLogout();
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!image || !title || order === "") {
      setMessage("Image, Title, and Order are required!");
      return;
    }

    setUploading(true);
    setMessage("");

    try {
      const storageRef = ref(storage, `banners/${Date.now()}_${image.name}`);
      const snapshot = await uploadBytes(storageRef, image);
      const imageUrl = await getDownloadURL(snapshot.ref);

      await addDoc(collection(db, "homeBanner"), {
        imageUrl,
        title,
        caption,
        title2,
        buttonText,
        buttonLink,
        order: Number(order),
      });

      setMessage("Image uploaded successfully!");
      setImage(null);
      setTitle("");
      setCaption("");
      setAnotherTitle("");
      setButtonText("");
      setButtonLink("");
      setOrder("");
      fetchImages();
    } catch (error) {
      console.error("Upload error:", error);
      setMessage("An error occurred during upload.");
    }

    setUploading(false);
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete?");
    if (confirmDelete) {
      try {
        await deleteDoc(doc(db, "homeBanner", id));
        setMessage("Image deleted successfully!");
        fetchImages();
      } catch (error) {
        console.error("Error deleting document:", error);
      }
    }
  };

  const handleEditClick = (item) => {
    setEditingItem(item);
  };

  const handleModalClose = () => {
    setEditingItem(null);
  };

  const handleModalSave = async (updatedData) => {
    try {
      const docRef = doc(db, "homeBanner", updatedData.id);
      const { id, ...dataWithoutId } = updatedData;
      await updateDoc(docRef, dataWithoutId);
      setMessage("Image details updated!");
      fetchImages();
      handleModalClose();
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  return (
    <div>
      <Header />
      <div className="container">
        <div className="card">
          <h1>Admin Panel</h1>
          <h2>Upload Image</h2>
          {message && <p className="message">{message}</p>}
          <form onSubmit={handleUpload}>
            <input type="file" accept="image/*" onChange={handleImageChange} />
            <input
              type="text"
              placeholder="Enter Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <input
              type="text"
              placeholder="Enter Another Title"
              value={title2}
              onChange={(e) => setAnotherTitle(e.target.value)}
            />
            <input
              type="text"
              placeholder="Enter Caption Text"
              value={caption}
              onChange={(e) => setCaption(e.target.value)}
            />

            <input
              type="text"
              placeholder="Enter Button Title"
              value={buttonText}
              onChange={(e) => setButtonText(e.target.value)}
            />
            <input
              type="text"
              placeholder="Enter Button Link"
              value={buttonLink}
              onChange={(e) => setButtonLink(e.target.value)}
            />
            <input
              type="number"
              placeholder="Enter Order"
              value={order}
              onChange={(e) => setOrder(e.target.value)}
            />
            <button type="submit" disabled={uploading}>
              {uploading ? "Uploading..." : "Upload"}
            </button>
          </form>
        </div>

        <div className="custom-gallery">
          <h2>Uploaded Images</h2>
          {images
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .map((item) => (
              <div key={item.id} className="custom-gallery-item">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="custom-gallery-img"
                />
                <div className="custom-gallery-details">
                  <h3>{item.title}</h3>
                  <p>{item.caption}</p>
                  <p>{item.title2}</p>
                  <p>Button: {item.buttonText}</p>
                  <p>Order: {item.order}</p>
                  <a
                    href={item.buttonLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.buttonText}
                  </a>
                  <div className="custom-gallery-actions">
                    <button
                      className="custom-edit-btn"
                      onClick={() => handleEditClick(item)}
                    >
                      Edit
                    </button>
                    <button
                      className="custom-delete-btn"
                      onClick={() => handleDelete(item.id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>

      {editingItem && (
        <EditModal
          item={editingItem}
          onClose={handleModalClose}
          onSave={handleModalSave}
        />
      )}
    </div>
  );
}
